import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../redux/configureStore';
import { setAccountCredt } from '../../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';
import { MaskedAccount } from '../../../../../../../../../utils/masks';

function SetAccountCred() {
  const dispatch = useDispatch();
  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );
  function setAccount(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    const onlyDigit = value.replace(/\D/g, '');
    dispatch(setAccountCredt(MaskedAccount(onlyDigit)));
  }

  return (
    <Wrapper.Default
      width="25%"
      style={{ padding: '0 15px 5px' }}
      isActive
      flexDirection="column"
      alignItens="start">
      <span
        style={{ paddingBottom: '5px', fontWeight: 700, lineHeight: '16px' }}>
        Conta com digito:
      </span>
      <Form.Control
        type="text"
        value={transfersFilterState.credt.account}
        onChange={(event) => setAccount(event)}
      />
    </Wrapper.Default>
  );
}

export default SetAccountCred;
